var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClubOut = function SvgClubOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6971_66462",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.04175 10.0003C1.04175 5.05515 5.0549 1.04199 10.0001 1.04199C10.3453 1.04199 10.6251 1.32181 10.6251 1.66699C10.6251 2.01217 10.3453 2.29199 10.0001 2.29199C5.74526 2.29199 2.29175 5.7455 2.29175 10.0003C2.29175 14.2551 5.74526 17.7087 10.0001 17.7087C14.2549 17.7087 17.7084 14.2551 17.7084 10.0003C17.7084 9.65515 17.9882 9.37533 18.3334 9.37533C18.6786 9.37533 18.9584 9.65515 18.9584 10.0003C18.9584 14.9455 14.9453 18.9587 10.0001 18.9587C5.0549 18.9587 1.04175 14.9455 1.04175 10.0003Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.225 1.89176C17.4691 1.64777 17.8648 1.64771 18.1088 1.89176C18.3528 2.13582 18.3528 2.5315 18.1088 2.77555L11.2753 9.60905C11.0313 9.85302 10.6356 9.85302 10.3915 9.60905C10.1475 9.365 10.1475 8.96934 10.3915 8.72526L17.225 1.89176Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7085 5.69206V2.29199H14.3084C13.9632 2.29199 13.6834 2.01217 13.6834 1.66699C13.6834 1.32181 13.9632 1.04199 14.3084 1.04199H18.3335C18.6786 1.04203 18.9585 1.32184 18.9585 1.66699V5.69206C18.9584 6.03718 18.6786 6.31702 18.3335 6.31706C17.9883 6.31706 17.7085 6.03721 17.7085 5.69206Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6971_66462)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  }))));
};
export default SvgClubOut;